var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9978 1.51147C11.1703 0.672607 12.8297 0.672607 14.0021 1.51147L14.011 1.51795L22.9051 8.16432C23.0389 8.26426 23.1176 8.42144 23.1176 8.5884V21.1741C23.1176 21.7184 22.9342 22.2132 22.5746 22.5734C22.215 22.9336 21.7205 23.1176 21.1764 23.1176H15.5294C15.237 23.1176 15 22.8806 15 22.5882V16.9317C15 15.6677 13.9656 14.6329 12.7059 14.6329H11.2941C10.0344 14.6329 8.99997 15.6677 8.99997 16.9317V22.5882C8.99997 22.8806 8.76295 23.1176 8.47056 23.1176H2.8235C2.2794 23.1176 1.78496 22.9336 1.42531 22.5734C1.06574 22.2132 0.882324 21.7184 0.882324 21.1741V8.5884C0.882324 8.42144 0.961085 8.26426 1.09483 8.16432L9.98895 1.51795L9.9978 1.51147ZM10.6181 2.36957L1.94115 8.85369V21.1741C1.94115 21.4783 2.04009 21.6905 2.17463 21.8253C2.3091 21.96 2.52054 22.0588 2.8235 22.0588H7.94115V16.9317C7.94115 15.0846 9.44793 13.5741 11.2941 13.5741H12.7059C14.552 13.5741 16.0588 15.0846 16.0588 16.9317V22.0588H21.1764C21.4794 22.0588 21.6908 21.96 21.8253 21.8253C21.9599 21.6905 22.0588 21.4783 22.0588 21.1741V8.85369L13.3818 2.36959C12.5794 1.79834 11.4206 1.79833 10.6181 2.36957Z",
    fill: "inherit"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.064fb82ca3f66fb454e2e14575d8af7b.svg";
export { ForwardRef as ReactComponent };